/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unnamed-components */

'use es6';

import { Component } from 'react';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isExpanded: true,
      valueExists: false
    };
    this.setLabelStates = (isExpanded, valueExists) => {
      this.setState({
        isExpanded,
        valueExists
      });
    };
    /**
     * Adds an 'expanded' class to the label when the input isn't focused.
     * Adds a 'value-exists' class to the label when a value exists in the input.
     * You can use these classes to animate the label/input.
     * A label should never have both 'expanded' and 'value-exists' applied.
     */
    this.inputFocused = () => {
      this.setLabelStates(false, false);
    };
    this.inputBlurred = () => {
      if (this.getInputValue()) {
        this.setLabelStates(false, true);
      } else {
        this.setLabelStates(true, false);
      }
    };
    this.getInputValue = () => {
      const inputVal = findDOMNode(this.refs.input).value;
      return inputVal ? inputVal.trim() : undefined;
    };
    this.getContainerClassName = isValid => {
      return !isValid() ? "invalid" : "";
    };
    this.getLabelClassName = () => {
      return classNames('label-text', this.state.isExpanded && "expanded", this.state.valueExists && 'value-exists');
    };
    this.renderNoticeText = () => {
      const {
        noticeText
      } = this.props;
      if (!noticeText) {
        return null;
      }
      return /*#__PURE__*/_jsx("div", {
        className: "notice-text",
        children: noticeText
      });
    };
  }
  componentDidMount() {
    if (this.getInputValue()) {
      // Rearrange the class structure if a value exists
      this.setLabelStates(false, true);
    }
  }
  render() {
    const {
      labelText,
      errorText,
      isValid,
      onChange,
      onBlur,
      value,
      type
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: this.getContainerClassName(isValid),
      children: [/*#__PURE__*/_jsxs("label", {
        children: [/*#__PURE__*/_jsx("span", {
          ref: "label",
          className: this.getLabelClassName(),
          children: labelText
        }), /*#__PURE__*/_jsx("input", {
          ref: "input",
          "data-test-id": this.props['data-test-id'],
          type: type,
          onFocus: this.inputFocused,
          onBlur: e => {
            if (typeof onBlur === 'function') {
              onBlur(e);
            }
            this.inputBlurred();
          },
          autoCapitalize: "off",
          autoCorrect: "off",
          onChange: onChange,
          value: value
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
          className: "error-text",
          children: errorText
        })]
      }), this.renderNoticeText()]
    });
  }
}